<template>
  <div :class="{'node': true, 'root': isRoot || !show, 'node-error-state': showError}">
    <div v-if="show" @click="onSelected" :class="{'node-body': true, 'error': showError,'node-body-disabled': (isProcess && title ==  '发起人')}" :style="{'background-color': headerBgc}">
      <div>
        <div class="node-body-header" >
          <!-- <i :class="headerIcon" style="margin-right: 5px" v-if="(headerIcon || '') !== ''"></i> -->
          <!-- <ellipsis class="name" hover-tip :content="title"/> -->
          <div class="name">{{ title }}</div>
          <i class="el-icon-close" v-if="!isRoot && $store.state.diagramMode !== 'viewer'" style="float:right;" @click="$emit('delNode')"></i>
        </div>
        <div class="node-body-content">
          <i :class="leftIcon" v-if="leftIcon"></i>
          <span class="placeholder" v-if="(content || '').trim() === ''">{{placeholder}}</span>
          <ellipsis :row="2" :content="content" v-else/>
          <i class="el-icon-arrow-right" v-if="$store.state.diagramMode !== 'viewer'" ></i>
        </div>
        <div class="node-error" v-if="showError">
          <el-tooltip effect="dark" :content="errorInfo" placement="top-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="node-footer">
      <div class="btn">
        <insert-button v-show="$store.state.diagramMode !== 'viewer'" @insertNode="type => $emit('insertNode', type)"></insert-button>
      </div>
    </div>
  </div>
</template>

<script>
import InsertButton from '@/pages/officeApproval/common/InsertButton.vue'

export default {
  name: "Node",
  components: {InsertButton},
  props:{
    //是否为根节点
    isRoot: {
      type: Boolean,
      default: false
    },
    //是否显示节点体
    show: {
      type: Boolean,
      default: true
    },
    //节点内容区域文字
    content: {
      type: String,
      default: ""
    },
    title:{
      type: String,
      default: "标题"
    },
    placeholder:{
      type: String,
      default: "请设置"
    },
    //节点体左侧图标
    leftIcon: {
      type: String,
      default: undefined
    },
    //头部图标
    headerIcon:{
      type: String,
      default: ''
    },
    //头部背景色
    headerBgc:{
      type: String,
      default: '#939696'
    },
    //是否显示错误状态
    showError:{
      type: Boolean,
      default: false
    },
    errorInfo:{
      type: String,
      default: '无信息'
    },
    isProcess: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  methods: {
    onSelected(){
      // 审批流，发起人不可修改
      if(this.isProcess && this.title ==  '发起人') {
        return
      }else{
        this.$emit('selected')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.root{
  &:before{
    display: none !important;
  }
}
.node-error-state{
  .node-body{
    box-shadow: 0px 0px 5px 0px #F56C6C !important;
  }
}
.node{
  padding: 0 50px;
  width: 268px;
  position: relative;

  .node-body{
    cursor: pointer;
    max-height: 184px;
    position: relative;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 0px 5px 0px #d8d8d8;
    padding-bottom: 8px;
    &:hover{
      // box-shadow: 0px 0px 3px 0px @theme-primary;
      .node-body-header {
        .el-icon-close {
          display: inline;
          font-size: medium;
        }
      }
    }
    .node-body-header{
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 12px 0 0 12px;
      box-sizing: border-box;
      
      height: 44px;
      .el-icon-close{
        display: none;
        color: #fff;
        position: absolute;
        font-size: 12px;
        right: 12px;
        top: 12px;
      }
      .name{
        
        color: white;
      font-size:14px;
      font-weight: bold;
      }
    }
    .node-body-content{
      margin: 0 0 0 12px;
      // padding: 18px;
      color: #656363;
      font-size: 14px;
      background-color: #fff;
      width: 244px;
      height: 52px;
      border-radius: 8px;
      box-sizing: border-box;
      padding-left: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      i{
        font-size: 16px;
        margin-right: 6px;
      }
      .placeholder{
        color: #C5C9C9;
      }
    }
    .node-error{
      position: absolute;
      right: -40px;
      top: 20px;
      font-size: 25px;
      color: #F56C6C;
    }
  }
  .node-body-disabled{
      cursor:default;
     .node-body-content i{
      display: none;
     }
  }
  .node-footer{
    position: relative;
    .btn{
      width: 100%;
      display: flex;
      padding: 28px 0 30px;
      justify-content: center;
    }
    /deep/ .el-button{
      height: 24px;
      width: 24px;
      padding: 0;
      .el-icon-plus{
        font-size: 14px;
      }
    }
    &::before{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      margin: auto;
      width: 2px;
      height: 100%;
      background-color: #C5C9C9;
    }
    &::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 0;
    border-style: solid;
    border-width: 8px 6px 0px;
    border-color: #C5C9C9 #F8FAFA #F8FAFA;
    background: #F8FAFA;
  }
  }
}
</style>
